import React from 'react'
import { Field } from 'redux-form'
import moment from 'moment-timezone'

import './DateTimeForm.scss'
import FrequencySelector from './components/FrequencySelector'
import MultipleDateSelector from './components/MultipleDateSelector'
import DateSelector from './components/DateSelector'
import TimeCounter from './components/TimeCounter'
import ProfileMobileNavBar from 'components/ProfileMobileNavBar'
import { formatDate } from 'utils/dates'
import { getNextServiceDate } from './utils'
import { isOperations } from 'utils/auth/user'
import { serviceTypes } from '@src/globals'

const DateTimeForm = (props) => {
  const {
    user,
    handleSubmit,
    selectedServiceTypeId
  } = props

  const displayMultipleDatesSelector = selectedServiceTypeId === serviceTypes.MULTIPLE.id

  return (
    <div className='DateTimeForm navbar-screen'>
      <ProfileMobileNavBar>
        Día y hora de tu servicio
      </ProfileMobileNavBar>

      <div className='DateTimeForm-content navbar-screen-content'>
        <div className='navbar-screen-container'>
          <form onSubmit={handleSubmit}>
            <div className='DateTimeForm-Fields'>
              <fieldset className='DateTimeForm-frequency'>
                <legend>
                  ¿Cada cuánto quieres tu servicio?
                </legend>

                <p>
                  Elige la frecuencia con la que quieres recibir a tu Aliada, ya sea semanal o una única vez.
                </p>

                <div className='DateTimeForm-FrequencySelector'>
                  <Field
                    name='serviceTypeId'
                    component={FrequencySelector}
                    />
                </div>
              </fieldset>

              {displayMultipleDatesSelector && <fieldset className='DateTimeForm-multipleDates'>
                <legend>
                  ¿Qué días quieres el servicio?
                </legend>

                <p>
                  Solo usa esta opción en caso de que estes agendando un servicio de multiple días a la semana.
                </p>

                <div className='DateTimeForm-MultipleDateSelector'>
                  <Field
                    name='weekdays'
                    component={MultipleDateSelector}
                    />
                </div>
              </fieldset>}

              <fieldset>
                <legend>
                  ¿Qué día comenzamos con tu servicio?
                </legend>

                <p>
                  El servicio se repetirá el mismo día, cada semana hasta que lo canceles. <strong>Cancelar a tiempo no tiene costo</strong>.
                </p>

                <div className='DateTimeForm-DateSelector'>
                  <Field
                    name='date'
                    component={DateSelector}
                    startDate={getNextServiceDate()}
                    parse={value => formatDate('YYYY-MM-DD', value)}
                    format={value => moment.tz(value, 'America/Mexico_City')}
                    />
                </div>

                <p className='help-block'>
                  Si quieres reservar más de un día por semana, lo podrás hacer desde tu perfil después de completar esta reservación.
                </p>
              </fieldset>

              <fieldset>
                <legend className='text-center'>
                  ¿A qué hora necesitas a tu Aliada?
                </legend>

                <Field
                  name='time'
                  min={7}
                  max={18}
                  formatValue={value => `${value}:00`}
                  component={TimeCounter}
                  type='time'
                  />
              </fieldset>
            </div>

            <div className='DateTimeForm-Button'>
              <button
                type='submit'
                className='btn btn-default btn-block btn-lg'
                >
                Encuentra tu Aliada ideal
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default DateTimeForm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/DateTimeForm/DateTimeForm.js